import "./BlogWriter.css"
import { addBlog } from "../../../../Misc/firebase"
export default function BlogWriter() {
    return (

        <div className="blog-writer mx-4 lg:mx-20">
            <div className="writer w-fit mx-auto flex-col flex space-y-5">
                <input type="text" id="title" className="w-full bg-slate-800 p-2" placeholder="Title"/>
                <textarea name="writer-blog" className="bg-slate-800 p-2" id="writer-blog" cols={80} rows={10} placeholder="HTML content">

                </textarea>
                <button className="w-fit px-10 py-2 bg-orange-500 mx-auto mt-10 rounded-lg" onClick={() => {
                    //add a blog
                    addBlog()
                }}>Post</button>
            </div>
        </div>
    )

}